//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Amount
import com.tixforgigs.apax.models.Invoice
import com.tixforgigs.apax.models.OrderEvent
import com.tixforgigs.apax.models.OrderItem
import com.tixforgigs.apax.models.OrderState
import com.tixforgigs.apax.models.PaymentState
import com.tixforgigs.apax.models.PaymentTypeId
import com.tixforgigs.apax.models.ShippingMethod

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The order model.
* 
* @param orderDate The order date.
* @param orderId The order id.
* @param orderState 
* @param orderToken The order token
* @param paymentState 
* @param paymentTypeId 
* @param subTotal 
* @param events A hint for the user to match order with event
* @param invoices List of invoices associated with the order
* @param orderItems List of order items in the order
* @param shippedDate The shipment date
* @param shippingMethod 
*/
@Serializable

data class Order (


      /* The order date. */
    @SerialName(value = "orderDate") @Required val orderDate: kotlin.time.Instant,


      /* The order id. */
    @SerialName(value = "orderId") @Required val orderId: kotlin.Int,


      @SerialName(value = "orderState") @Required val orderState: OrderState,


      /* The order token */
    @SerialName(value = "orderToken") @Required val orderToken: kotlin.String,


      @SerialName(value = "paymentState") @Required val paymentState: PaymentState,


      @SerialName(value = "paymentTypeId") @Required val paymentTypeId: PaymentTypeId,


      @SerialName(value = "subTotal") @Required val subTotal: Amount,


      /* A hint for the user to match order with event */
    @SerialName(value = "events") val events: kotlin.collections.List<OrderEvent>? = null,


      /* List of invoices associated with the order */
    @SerialName(value = "invoices") val invoices: kotlin.collections.List<Invoice>? = null,


      /* List of order items in the order */
    @SerialName(value = "orderItems") val orderItems: kotlin.collections.List<OrderItem>? = null,


      /* The shipment date */
    @SerialName(value = "shippedDate") val shippedDate: kotlin.time.Instant? = null,


      @SerialName(value = "shippingMethod") val shippingMethod: ShippingMethod? = null


) {




  }

